const SET_FULLSCREEN_STATUS = "SET_FULLSCREEN_STATUS"


const state = {
    isFullscreen:false

}
const mutations = {
    [SET_FULLSCREEN_STATUS]: function (state, payload) {
        state.isFullscreen = payload.status;
    },
}
const actions = {
    setFullscreenStatus({ commit }, payload) {
        commit('SET_FULLSCREEN_STATUS', payload)
    },
  
    
}

export const fullscreen=  {
    namespaced: true,
    state,
    mutations,
    actions
}